export default "__VITE_PUBLIC_ASSET__fc595db6__"